export default __webpack_public_path__ + "static/media/chatxbt.95856e12.gif";